export default __webpack_public_path__ + "static/media/2.ff828f86.jpg";